import { cache } from '@/container/apollo-client/cache';
import { QUERY_GET_NOTIFICATION_COUNT } from '@/graphql/query.graphql';
import { NotificationV2, ObtainNotificationCountQuery } from '@/types/generated/graphql';
import { create } from 'zustand';
import { useMarkAllSeen } from './use-mark-all-seen';
import { removeFromCache } from '@shared/utils/cache-helper';

type NotificationToggle = {
  isOpen: boolean;
  openNotification: VoidFunction;
  closeNotification: VoidFunction;
};

export const useNotificationToggleStore = create<NotificationToggle>((set) => ({
  isOpen: false,
  openNotification: () => set({ isOpen: true }),
  closeNotification: () => set({ isOpen: false }),
}));

export const useNotificationToggle = (
  getNotifications: VoidFunction,
  markedNotificationIds: number[],
  firstNotificationId: NotificationV2['id'],
  setMarkedNotificationIds: (data: number[]) => void
) => {
  const { isOpen, openNotification, closeNotification } = useNotificationToggleStore();
  const { markAllSeenHandler } = useMarkAllSeen();

  function resetCounter() {
    cache.updateQuery<ObtainNotificationCountQuery>({ query: QUERY_GET_NOTIFICATION_COUNT }, (data) => {
      return {
        ...data,
        obtainNotificationCount: {
          ...data?.obtainNotificationCount,
          data: {
            ...data?.obtainNotificationCount?.data,
            count: 0,
          },
        },
      };
    });
  }

  function openNotificationHandler() {
    getNotifications();
    openNotification();
  }

  function closeNotificationHandler() {
    closeNotification();
    markAllSeenHandler(firstNotificationId);
    resetCounter();
    if (markedNotificationIds?.length) {
      removeFromCache(markedNotificationIds, 'NotificationV2');
    }
    setMarkedNotificationIds([]);
  }

  return {
    isNotificationOpen: isOpen,
    openNotification: openNotificationHandler,
    closeNotification: closeNotificationHandler,
  };
};
